import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '../utils/cn';
import { TONE_CLASSES, type Tone } from '../utils/statusTone';

export interface ILMSKPIProps {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  tone?: Tone;
  trend?: { direction: 'up' | 'down' | 'flat'; label: string; good?: boolean };
  helperText?: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export function ILMSKPI({ label, value, icon, tone = 'neutral', trend, helperText, onClick, className }: ILMSKPIProps) {
  const classes = TONE_CLASSES[tone];
  const TrendIcon = trend?.direction === 'up' ? TrendingUp : trend?.direction === 'down' ? TrendingDown : Minus;
  const trendTone = trend ? (trend.good === false ? 'critical' : trend.good === true ? 'success' : 'neutral') : 'neutral';

  const Comp = onClick ? 'button' : 'div';

  return (
    <Comp
      onClick={onClick}
      className={cn(
        'bg-white rounded-lg border border-ink-300/20 shadow-card p-4 sm:p-5 text-left w-full',
        onClick && 'hover:border-brand-green-300 transition-colors cursor-pointer',
        className
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-label text-ink-500 uppercase tracking-wide">{label}</p>
        {icon && (
          <span className={cn('h-8 w-8 rounded-md flex items-center justify-center shrink-0 [&>svg]:h-4 [&>svg]:w-4', classes.bg, classes.text)}>
            {icon}
          </span>
        )}
      </div>
      <p className="text-kpi-number text-ink-900 mt-1 tabular-nums">{value}</p>
      {(trend || helperText) && (
        <div className="flex items-center gap-2 mt-1.5 flex-wrap">
          {trend && (
            <span className={cn('inline-flex items-center gap-1 text-xs font-medium', TONE_CLASSES[trendTone].text)}>
              <TrendIcon className="h-3.5 w-3.5" aria-hidden="true" />
              {trend.label}
            </span>
          )}
          {helperText && <span className="text-helper-text text-ink-400">{helperText}</span>}
        </div>
      )}
    </Comp>
  );
}
